import { decodeBase64, encodeBase64 } from "./base64";

/**
 * Search Analytics の URL グループIDから Project ID を復元する。
 * ID 形式: URLGroup:customers/{org}/projects/{project}/search_analytics/{sa}/url_groups/{group}
 * @param urlGroupId Base64 エンコード済みの URL グループID
 * @returns Base64 エンコード済み Project ID（失敗時は null）
 */
export function toProjectIdFromSaUrlGroupId(urlGroupId: string): string | null {
  try {
    const decoded = decodeBase64(urlGroupId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    if (!orgDb || !projectDb) return null;
    const rawProject = `Project:customers/${orgDb}/projects/${projectDb}`;
    return encodeBase64(rawProject);
  } catch {
    return null;
  }
}

/**
 * Search Analytics の URL グループIDから SearchAnalytics ID を復元する。
 * @param urlGroupId Base64 エンコード済みの URL グループID
 * @returns Base64 エンコード済み SearchAnalytics ID（失敗時は null）
 */
export function toSearchAnalyticsIdFromSaUrlGroupId(
  urlGroupId: string,
): string | null {
  try {
    const decoded = decodeBase64(urlGroupId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    const saDb = parts[5];
    if (!orgDb || !projectDb || !saDb) return null;
    const rawSa = `SearchAnalytics:customers/${orgDb}/projects/${projectDb}/search_analytics/${saDb}`;
    return encodeBase64(rawSa);
  } catch {
    return null;
  }
}
